/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create and update a rule.
 * 
 * ``extra_params`` is validated against the action's declared spec, which is where reference
 * params are checked for resolving inside their scope — the same rule the admin's
 * ActionParamsField enforces.
 * 
 * ``position`` is read-only: the server owns it. New rules are appended, and order is changed
 * through the reorder endpoint, which is what keeps the per-action uniqueness constraint
 * satisfiable.
 * @export
 * @interface PatchedActionRuleWriteRequest
 */
export interface PatchedActionRuleWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedActionRuleWriteRequest
     */
    transitionAction?: string;
    /**
     * Leave empty for a rule that always matches.
     * @type {string}
     * @memberof PatchedActionRuleWriteRequest
     */
    condition?: string | null;
    /**
     * Parameters passed to the action when this rule matches.
     * @type {any}
     * @memberof PatchedActionRuleWriteRequest
     */
    extraParams?: any | null;
}

/**
 * Check if a given object implements the PatchedActionRuleWriteRequest interface.
 */
export function instanceOfPatchedActionRuleWriteRequest(value: object): value is PatchedActionRuleWriteRequest {
    return true;
}

export function PatchedActionRuleWriteRequestFromJSON(json: any): PatchedActionRuleWriteRequest {
    return PatchedActionRuleWriteRequestFromJSONTyped(json, false);
}

export function PatchedActionRuleWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedActionRuleWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transitionAction': json['transition_action'] == null ? undefined : json['transition_action'],
        'condition': json['condition'] === undefined ? undefined : json['condition'] === null ? null : json['condition'],
        'extraParams': json['extra_params'] === undefined ? undefined : json['extra_params'] === null ? null : json['extra_params'],
    };
}

export function PatchedActionRuleWriteRequestToJSON(json: any): PatchedActionRuleWriteRequest {
    return PatchedActionRuleWriteRequestToJSONTyped(json, false);
}

export function PatchedActionRuleWriteRequestToJSONTyped(value?: PatchedActionRuleWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition_action': value['transitionAction'],
        'condition': value['condition'],
        'extra_params': value['extraParams'],
    };
}

